import { Row } from '@tanstack/react-table';

import { CatalogItem } from '@/pages/Catalog/types';
import { SelectedSymbol } from '@/types/symbols';

export const parseForwardCurveRowToSymbol = (row: Row<CatalogItem>) => {
  const periodMin = row.getValue<number>('PeriodMin');
  const periodMax = row.getValue<number>('PeriodMax');
  const baseSymbol = row.getValue<SelectedSymbol>('Symbol');
  const selectedSymbols: SelectedSymbol[] = [];
  if (baseSymbol) {
    for (let i = periodMin; i <= periodMax; i++) {
      selectedSymbols.push({
        Code: baseSymbol.Code,
        TimeRef: baseSymbol.TimeRef,
        Period: i.toString(),
        PeriodType: baseSymbol.PeriodType
      });
    }
  }
  return selectedSymbols;
};
